import {api} from 'helpers';
import {put, call} from 'redux-saga/effects';
import {watch} from 'store/effects';
import {userIsOnline} from 'store/session';

export function* serverReadExtra() {
  yield watch(userIsOnline, function* (isOnline, prev, action) {
    if (isOnline && action.type != 'APP_HOT_LAUNCH') {
      yield put({
        type: 'SERVER_CLARITY_LOADED',
        data: yield call(api, '/get-clarity/'),
      });
      yield put({
        type: 'SERVER_IDENTITY_LOADED',
        data: yield call(api, '/get-identity/'),
      });
    }
  });
}
